import React, { useState } from "react";
import { experience } from "../content";

/* A single role inside an organisation block. */
const Role = ({ title, duration, type, location, stack, bullets, note, current }) => (
  <div className={current ? "role role--current" : "role"}>
    <h4 className="role-title">{title}</h4>

    <div className="meta meta-row role-meta">
      <span>{duration}</span>
      <span className="meta-dot" />
      <span>{type}</span>
      {location && (
        <>
          <span className="meta-dot" />
          <span>{location}</span>
        </>
      )}
    </div>

    {stack && stack.length > 0 && (
      <div className="tag-row role-stack">
        {stack.map((t) => (
          <span className="tag" key={t}>
            {t}
          </span>
        ))}
      </div>
    )}

    {note && <p className="role-note">{note}</p>}

    {bullets && bullets.length > 0 && (
      <ul className="bullets">
        {bullets.map((b, i) => (
          <li key={i}>{b}</li>
        ))}
      </ul>
    )}
  </div>
);

/* An organisation and all the roles held there — LinkedIn's grouping. */
const Org = ({ org, mark, tenure, roles }) => {
  const multi = roles.length > 1;
  return (
    <article className="org">
      <div className="org-mark" aria-hidden="true">
        {mark}
      </div>

      <div className="org-head">
        <h3 className="org-name">{org}</h3>
        <div className="meta org-tenure">
          {tenure}
          {multi && ` · ${roles.length} roles`}
        </div>
      </div>

      <div className={multi ? "org-roles is-multi" : "org-roles"}>
        {roles.map((role) => (
          <Role key={role.title} {...role} />
        ))}
      </div>
    </article>
  );
};

const Experience = () => {
  const [active, setActive] = useState(experience[0].id);
  const current = experience.find((c) => c.id === active);
  const roleCount = current.orgs.reduce((n, o) => n + o.roles.length, 0);

  return (
    <section id="experience" className="section section--ruled">
      <div className="shell shell--narrow">
        <div className="section-head">
          <p className="eyebrow">Experience</p>
          <h2 className="section-title">Where I've worked</h2>
        </div>

        <div className="reveal">
          <div className="tabs" role="tablist" aria-label="Experience categories">
            {experience.map((cat) => {
              const isActive = cat.id === active;
              const count = cat.orgs.reduce((n, o) => n + o.roles.length, 0);
              return (
                <button
                  key={cat.id}
                  type="button"
                  role="tab"
                  id={`tab-${cat.id}`}
                  aria-selected={isActive}
                  aria-controls={`panel-${cat.id}`}
                  className={isActive ? "tab is-active" : "tab"}
                  onClick={() => setActive(cat.id)}
                >
                  {cat.label}
                  <span className="tab-count">{count}</span>
                </button>
              );
            })}
          </div>

          <p className="tab-desc">
            {current.desc} · {roleCount} roles
          </p>

          <div
            role="tabpanel"
            id={`panel-${active}`}
            aria-labelledby={`tab-${active}`}
            key={active}
            className="fade-in"
          >
            {current.orgs.map((org) => (
              <Org key={org.org} {...org} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
